import Modal from "react-bootstrap/Modal";
import {useState} from "react";
import axiApi from "ApiCaller";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {addOrUpdateList} from "core/utils/arrays";


const ModalCreateGroup = (props) => {

    const Group = {
        id: "",
        name: "",
    }

    const [formData, setFormData] = useState(Group)

    const handleChange = (event) => {
        const {name, value} = event.target;
        formData[name] = value;
        setFormData(formData);
    }

    const handleClose = () => {
        props.setShowForm(false);
    }

    const onSummit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        axiApi.post(`/api/assets/group/`, formData).then((resp) => {
            if (resp.status === 200) {
                if (formData.id) {
                    props.items.current.showed = addOrUpdateList(props.items.current.showed, resp.data.item);
                    props.items.current.all = addOrUpdateList(props.items.current.all, resp.data.item);
                } else {
                    props.items.current.all.push(resp.data.item);
                    props.items.current.showed.push(resp.data.item);
                }

                props.setItemsShow([...props.items.current.showed]);
                props.setShowForm(false);
            }

        }).catch((error) => {
            console.error('Error al enviar la solicitud:', error);
        });

    }

    return (
        <>
            <Modal show={props.showForm} onHide={handleClose} animation={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="object-group"/>
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline">Crear Grupo</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <form className="ms-auto" onSubmit={onSummit}>
                        <div className="col-12 mt-4 mb-4">
                            <input type="text" className="form-control" id="name" name="name"
                                   defaultValue={formData.name} placeholder="Name" onChange={handleChange}
                                   required/>
                        </div>
                        <div className="mt-5 text-end mb-5">
                            <div className="mt-5 d-flex justify-content-end align-right">
                                <button type="button" className="btn btn-secondary"
                                        onClick={handleClose}>Cancel
                                </button>
                                <button type="submit" className="btn btn-primary ms-4">Crear</button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>

    )
        ;


}

export default ModalCreateGroup